import template from './netverify.html';
class SetupNetverifyController {
    constructor($stateParams, GmwNetVerify, GmwModal, gettextCatalog) {
        this.$stateParams = $stateParams;
        this.GmwNetVerify = GmwNetVerify;
        this.GmwModal = GmwModal;
        this.gettextCatalog = gettextCatalog;
        this.$onInit = () => {
            this.init(true);
        };
        this.$onDestroy = () => {
            this.GmwNetVerify.tearDown();
        };
        this.retry = () => {
            this.init(true);
        };
        this.upload = () => {
            const confirmationPrompt = this.gettextCatalog.getString('Uploading an ID rather than using a camera to capture can lead to longer review and verification times. Proceed?');
            this.GmwModal.showConfirmationModal(confirmationPrompt)
                .then(() => {
                this.init(false);
            });
        };
    }
    init(requireWebcam) {
        this.error = undefined;
        this.isUpload = !requireWebcam;
        this.GmwNetVerify.init(this.$stateParams.code, requireWebcam)
            .then(({ url, promise }) => {
            this.iframeSrc = url;
            promise.then(() => {
                this.onComplete();
            })
                .catch((errorCode) => {
                this.error = errorCode;
            });
        });
    }
}
SetupNetverifyController.$inject = [
    '$stateParams',
    'GmwNetVerify',
    'GmwModal',
    'gettextCatalog',
];
const Eid = {
    bindings: {
        onComplete: '&',
    },
    controller: SetupNetverifyController,
    template,
};
const componentName = 'gmwSetupNetverify';
angular.module('app.holding.dashboard.onboarding').component(componentName, Eid);
export default componentName;



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/onboarding/controllers/setup/documents/netverify/netverify.ts